"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = __importStar(require("@seaweb/coral/hoc/styled"));
var react_textarea_autosize_1 = __importDefault(require("react-textarea-autosize"));
var react_resize_aware_1 = __importDefault(require("react-resize-aware"));
var useControlProp_1 = __importDefault(require("@seaweb/coral/hooks/useControlProp"));
var useWrapEvent_1 = __importDefault(require("@seaweb/coral/hooks/useWrapEvent"));
var useForkRef_1 = __importDefault(require("@seaweb/coral/hooks/useForkRef"));
var fallback_1 = __importDefault(require("@seaweb/coral/utils/fallback"));
var color_1 = require("@seaweb/coral/utils/color");
var Field_1 = require("@seaweb/coral/components/Field");
var TextFieldContext_1 = __importDefault(require("./TextFieldContext"));
var styles_1 = require("./styles");
var StyledPlaceholder = styled_1.default(styles_1.Placeholder).attrs({
    'data-coral-text-area-placeholder': '',
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var spacing = _a.theme.spacing;
    return styled_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    /* 1px is to compensate the border */\n    left: ", "px;\n    right: ", "px;\n    top: ", "px;\n  "], ["\n    /* 1px is to compensate the border */\n    left: ", "px;\n    right: ", "px;\n    top: ", "px;\n  "])), 3 * spacing.factor + 1, 3 * spacing.factor + 1, 2.5 * spacing.factor);
});
var WrappedTextArea = react_1.forwardRef(function WrappedTextArea(_a, ref) {
    var paddingBottom = _a.paddingBottom, fullWidth = _a.fullWidth, props = __rest(_a, ["paddingBottom", "fullWidth"]);
    return react_1.default.createElement(react_textarea_autosize_1.default, __assign({}, props, { ref: ref }));
});
var StyledTextArea = styled_1.default(WrappedTextArea)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n\n  line-height: 1.43;\n  resize: none;\n\n  ", "\n"], ["\n  ", "\n\n  line-height: 1.43;\n  resize: none;\n\n  ",
    "\n"])), styles_1.baseStyle, function (_a) {
    var paddingBottom = _a.paddingBottom, fullWidth = _a.fullWidth, factor = _a.theme.spacing.factor;
    return styled_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    width: ", ";\n    ", "\n  "], ["\n    width: ", ";\n    ",
        "\n  "])), fullWidth ? '100%' : '420px', paddingBottom
        ? styled_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n          padding-bottom: ", "px;\n        "], ["\n          padding-bottom: ", "px;\n        "])), paddingBottom + 2 * factor) : '');
});
var AddOnBottom = styled_1.default.div.attrs({ 'data-coral-text-area-addon': 'bottom' })(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  position: absolute;\n  /* compensate for border */\n  bottom: 1px;\n\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  position: absolute;\n  /* compensate for border */\n  bottom: 1px;\n\n  ",
    "\n"])), function (_a) {
    var focused = _a.focused, disabled = _a.disabled, _b = _a.theme, _c = _b.spacing, factor = _c.factor, radius = _c.radius, colors = _b.colors;
    return styled_1.css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    padding: ", "px 0;\n    border-radius: 0 0 ", "px ", "px;\n    left: ", "px;\n    right: ", "px;\n\n    /* use mix instead of alp so that it blends with the background and not overlap */\n    ", "\n  "], ["\n    padding: ", "px 0;\n    border-radius: 0 0 ", "px ", "px;\n    left: ", "px;\n    right: ", "px;\n\n    /* use mix instead of alp so that it blends with the background and not overlap */\n    ",
        "\n  "])), factor / 2, radius, radius, factor / 2, factor / 2, disabled
        ? styled_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n          background-color: ", ";\n        "], ["\n          background-color: ", ";\n        "])), color_1.mix(colors.alternate, colors.plain, 90)) : styled_1.css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n          background-color: ", ";\n        "], ["\n          background-color: ", ";\n        "])), focused ? colors.plain : color_1.mix(colors.fade, colors.plain, 80)));
});
var TextArea = react_1.forwardRef(function TextArea(_a, ref) {
    var as = _a.as, idProp = _a.id, disabled = _a.disabled, _b = _a.bottomElement, bottom = _b === void 0 ? null : _b, valueProp = _a.value, _c = _a.defaultValue, defaultValue = _c === void 0 ? '' : _c, onChange = _a.onChange, onFocus = _a.onFocus, onBlur = _a.onBlur, _d = _a.fullWidth, fullWidth = _d === void 0 ? false : _d, wrapperProps = _a.wrapperProps, placeholder = _a.placeholder, children = _a.children, invalidProp = _a.invalid, _e = _a["aria-describedby"], ariaDescribedby = _e === void 0 ? '' : _e, _f = _a["aria-labelledby"], ariaLabelledby = _f === void 0 ? '' : _f, props = __rest(_a, ["as", "id", "disabled", "bottomElement", "value", "defaultValue", "onChange", "onFocus", "onBlur", "fullWidth", "wrapperProps", "placeholder", "children", "invalid", 'aria-describedby', 'aria-labelledby']);
    var _g = __read(useControlProp_1.default(valueProp, defaultValue), 2), value = _g[0], setValue = _g[1];
    var handleChange = function (e) {
        setValue(e.target.value);
        if (onChange) {
            onChange(e);
        }
    };
    var id = Field_1.useId(idProp);
    var placeholderId = "text-area:" + id + "-placeholder";
    var ariaAttrs = Field_1.useFieldAria({
        'aria-labelledby': ariaLabelledby,
        'aria-describedby': [value ? '' : placeholderId, ariaDescribedby].join(' ').trim(),
        'aria-invalid': invalidProp,
    });
    var invalid = fallback_1.default(invalidProp, Field_1.useFieldContext().invalid);
    var inputRef = react_1.useRef(null);
    var handleRef = useForkRef_1.default(ref, inputRef);
    var ctx = {
        id: id,
        value: value,
        onChange: handleChange,
        inputRef: inputRef,
        disabled: disabled,
    };
    var dataCoral = {
        'data-coral-rounded': '',
    };
    if (invalid) {
        dataCoral['data-coral-invalid'] = '';
    }
    if (disabled) {
        dataCoral['data-coral-disabled'] = '';
    }
    var _h = __read(react_resize_aware_1.default(), 2), bottomListener = _h[0], bottomSizes = _h[1];
    var paddingBottom = bottom === null ? null : bottomSizes.height;
    var _j = __read(react_1.useState(false), 2), focused = _j[0], setFocused = _j[1];
    var handleFocus = useWrapEvent_1.default(onFocus, function () { return setFocused(true); });
    var handleBlur = useWrapEvent_1.default(onBlur, function () { return setFocused(false); });
    return (react_1.default.createElement(TextFieldContext_1.default.Provider, { value: ctx },
        react_1.default.createElement(styles_1.TextFieldWrapper, __assign({ fullWidth: fullWidth, disabled: disabled }, wrapperProps),
            children,
            react_1.default.createElement(StyledTextArea, __assign({ as: as, ref: handleRef, id: idProp, value: value, disabled: disabled, onChange: handleChange, onFocus: handleFocus, onBlur: handleBlur, paddingBottom: paddingBottom, fullWidth: fullWidth }, ariaAttrs, dataCoral, props)),
            !("" + value) && (react_1.default.createElement(StyledPlaceholder, { id: placeholderId, disabled: disabled }, placeholder)),
            bottom && (react_1.default.createElement(AddOnBottom, { focused: focused, disabled: disabled },
                bottomListener,
                bottom)))));
});
exports.default = react_1.memo(TextArea);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
